export default (data) => ({
  type: 'DELETE_JOB',
  payload: data,
});
